export const pauseAllVideos = () => {
  document.querySelectorAll('video').forEach(vid => vid.pause());
};
